import CustomerThematicFigureList from "../../components/customerThematic/CustomerThematicFigureList";

const CustomerThematicPage = () => {

    return <CustomerThematicFigureList/>
}

export default CustomerThematicPage;
